var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRamadanOffersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M25.066 16.534a1.643 1.643 0 0 1 0-1.066l.815-2.517a1.751 1.751 0 0 0-.622-1.94l-2.147-1.554a1.589 1.589 0 0 1-.622-.858l-.829-2.517a1.707 1.707 0 0 0-1.643-1.185h-.415c-.355 0-.71-.118-1.007-.325L16.45 3.017a1.71 1.71 0 0 0-2.028 0l-2.147 1.555a1.773 1.773 0 0 1-1.007.325h-2.65c-.74 0-1.407.474-1.644 1.185L6.16 8.599c-.118.355-.34.651-.622.873l-2.146 1.555a1.7 1.7 0 0 0-.622 1.924l.814 2.517c.104.356.104.726 0 1.066l-.814 2.517c-.237.71.015 1.496.622 1.94l2.146 1.554c.282.207.504.518.622.859l.814 2.517c.237.71.904 1.199 1.644 1.199h2.65c.355 0 .71.104 1.007.326L14.42 29a1.71 1.71 0 0 0 2.029 0l2.146-1.554a1.669 1.669 0 0 1 1.007-.326h2.65c.09 0 .193 0 .282-.03-.09.015-.193.015-.282.015h-2.235c.755 0 1.421-.474 1.643-1.184l.83-2.517a1.68 1.68 0 0 1 .621-.874l2.147-1.554c.592-.43.858-1.214.622-1.925l-.815-2.517zm-12.94-1.924a1.742 1.742 0 0 1-1.79-1.659 1.723 1.723 0 0 1 1.657-1.791 1.722 1.722 0 0 1 1.792 1.658c.03.948-.71 1.747-1.658 1.792zm6.752 6.247a1.742 1.742 0 0 1-1.792-1.658 1.724 1.724 0 0 1 1.659-1.791 1.713 1.713 0 0 1 1.791 1.658 1.722 1.722 0 0 1-1.658 1.791z",
    fill: "url(#o5xtdefwna)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2.755 19.05c-.222.71.03 1.495.637 1.924l2.132 1.555c.296.222.518.518.636.874l.814 2.517a1.72 1.72 0 0 0 1.644 1.184h2.235A1.707 1.707 0 0 1 9.21 25.92l-.83-2.517a1.681 1.681 0 0 0-.62-.874l-2.148-1.555a1.722 1.722 0 0 1-.621-1.924l.814-2.517c.118-.34.118-.726 0-1.066L4.99 12.95c-.237-.71.03-1.495.621-1.94L7.76 9.457a1.59 1.59 0 0 0 .622-.859l.829-2.516a1.707 1.707 0 0 1 1.643-1.185H8.618a1.72 1.72 0 0 0-1.644 1.185L6.16 8.597c-.118.356-.34.652-.636.86L3.392 11.01a1.758 1.758 0 0 0-.637 1.94l.83 2.516c.103.34.103.725-.001 1.066l-.829 2.517z",
    fill: "url(#ppxfc84stb)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.618 11.468-8.365 9.061M16.449 3l2.147 1.555c.296.208.652.326 1.022.326h2.65c.755 0 1.406.489 1.643 1.2l.814 2.516c.119.34.326.652.622.859l2.147 1.554c.607.444.859 1.214.622 1.94l-.814 2.517c-.119.34-.119.725 0 1.066l.814 2.517a1.728 1.728 0 0 1-.622 1.94l-2.147 1.554a1.645 1.645 0 0 0-.622.858l-.814 2.517c-.237.71-.888 1.2-1.643 1.2h-2.65c-.37 0-.726.118-1.022.325l-2.147 1.555a1.71 1.71 0 0 1-2.028 0l-2.147-1.555a1.784 1.784 0 0 0-1.021-.326h-2.65a1.733 1.733 0 0 1-1.644-1.199l-.814-2.517a1.73 1.73 0 0 0-.622-.858l-2.147-1.555a1.721 1.721 0 0 1-.621-1.94l.814-2.516c.118-.34.118-.726 0-1.066l-.814-2.517a1.728 1.728 0 0 1 .621-1.94l2.147-1.554c.296-.207.518-.518.622-.859l.814-2.517c.237-.71.889-1.199 1.644-1.199h2.65c.37 0 .725-.118 1.021-.326L14.421 3a1.71 1.71 0 0 1 2.028 0zm4.101 16.124a1.732 1.732 0 1 1-3.464 0 1.732 1.732 0 0 1 3.465 0zm-6.75-6.248a1.732 1.732 0 1 1-3.465 0 1.732 1.732 0 0 1 3.464 0z",
    stroke: "url(#nk90nofyyc)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "o5xtdefwna",
    x1: 2.682,
    y1: 18.181,
    x2: 26.326,
    y2: 11.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ppxfc84stb",
    x1: 2.675,
    y1: 17.81,
    x2: 11.527,
    y2: 16.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nk90nofyyc",
    x1: 2.667,
    y1: 18.172,
    x2: 28.211,
    y2: 10.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRamadanOffersIcon);
export default __webpack_public_path__ + "static/media/ramadanOffersIcon.af31e92ded3ecd2ed17b4392b2798b10.svg";
export { ForwardRef as ReactComponent };